export const FroalaFontFamilies = {
  "'Open Sans', sans-serif": 'Open Sans',
  'Tinos,serif': 'Tinos',
  'Lato,sans-serif': 'Lato',
  'Roboto,sans-serif': 'Roboto',
  "'Roboto Mono',sans-serif": 'Roboto Mono',
  'Anton,sans-serif': 'Anton',
  'Oswald,sans-serif': 'Oswald',
  'Montserrat,sans-serif': 'Montserrat',
  "'Open Sans Condensed',sans-serif": 'Open Sans Condensed',
  'Georgia,serif': 'Georgia',
}
